// import React from "react";
// import { ComponentConfig } from "../../../../core/types";
// import styles from "./styles.module.css";
// import { getClassNameFactory } from "../../../../core/lib";
// import { Button } from "../../../../core/components/Button";
// import { Section } from "../../components/Section";

// const getClassName = getClassNameFactory("ButtonGroup", styles);

// export type ButtonGroupProps = {
//   align?: string;
//   buttons: { label: string; href: string; variant: "primary" | "secondary" }[];
// };

// export const ButtonGroup: ComponentConfig<ButtonGroupProps> = {
//   label: "Button Group",
//   fields: {
//     buttons: {
//       type: "array",
//       getItemSummary: (item) => item.label || "Button",
//       arrayFields: {
//         label: { type: "text" },
//         href: { type: "text" },
//         variant: {
//           type: "radio",
//           options: [
//             { label: "primary", value: "primary" },
//             { label: "secondary", value: "secondary" },
//           ],
//         },
//       },
//       defaultItemProps: {
//         label: "Button",
//         href: "#",
//         variant: "primary",
//       },
//     },
//     align: {
//       type: "radio",
//       options: [
//         { label: "left", value: "left" },
//         { label: "center", value: "center" },
//       ],
//     },
//   },
//   defaultProps: {
//     buttons: [{ label: "Learn more", href: "#", variant: "primary" }],
//   },
//   render: ({ align, buttons, puck }) => {
//     return (
//       <Section className={getClassName({ center: align === "center" })}>
//         <div className={getClassName("actions")}>
//           {buttons.map((button, i) => (
//             <Button
//               key={i}
//               href={button.href}
//               variant={button.variant}
//               size="large"
//               onClick={(e) => {
//                 e.preventDefault(); // Prevent default behavior (optional)
//                 window.open(button.href, "_blank", "noopener,noreferrer");
//               }}
//               tabIndex={puck.isEditing ? -1 : undefined}
//             >
//               {button.label}
//             </Button>
//           ))}
//         </div>
//       </Section>
//     );
//   },
// };
import React from "react";
import { ComponentConfig } from "../../../../core/types";
import styles from "./styles.module.css";
import { getClassNameFactory } from "../../../../core/lib";
import { Button } from "../../../../core/components/Button";
import { Section } from "../../components/Section";

const getClassName = getClassNameFactory("ButtonGroup", styles);

export type ButtonGroupProps = {
  align?: string;
  buttons: { label: string; href: string; variant: "primary" | "secondary" }[];
};

export const ButtonGroup: ComponentConfig<ButtonGroupProps> = {
  label: "Button Group",
  fields: {
    buttons: {
      type: "array",
      getItemSummary: (item) => item.label || "Button",
      arrayFields: {
        label: { type: "text" },
        href: { type: "text" },
        variant: {
          type: "radio",
          options: [
            { label: "primary", value: "primary" },
            { label: "secondary", value: "secondary" },
          ],
        },
      },
      defaultItemProps: {
        label: "Button",
        href: "#",
        variant: "primary",
      },
    },
    align: {
      type: "radio",
      options: [
        { label: "left", value: "left" },
        { label: "center", value: "center" },
      ],
    },
  },
  defaultProps: {
    buttons: [{ label: "Learn more", href: "#", variant: "primary" }],
  },
  render: ({ align, buttons, puck }) => {
    
    // Function to handle button click
    const handleButtonClick = async (href: string, label: string) => {
      debugger;
      console.log(label);
      try {
        const response = await fetch(href); // API Call
        const data = await response.json(); // Parse JSON

        // Button label ko API response ke sath bhejna
        showDataOnNewPage(data, label);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Function to create a new page and render API response in Puck Editor
    const showDataOnNewPage = (data: any, label: string) => {
      const newWindow = window.open("", "_blank");
      if (newWindow) {
        newWindow.document.write(`
          <html>
              <head>
                  <title>${label}</title>
                  <script src="https://puckeditor.com/puck.min.js"></script>
              </head>
              <body>
                  <h2>${label}</h2> <!-- Button Label Show Karna -->
                  <div id="editor"></div>
                  <script>
                      var editor = new Puck({ element: document.getElementById('editor') });
                      editor.setContent(${JSON.stringify(data)});
                  </script>
              </body>
          </html>
        `);
      }
    };

    return (
      <Section className={getClassName({ center: align === "center" })}>
        <div className={getClassName("actions")}>
          {buttons.map((button, i) => (
            <Button
              key={i}
              href={button.href}
              variant={button.variant}
              size="large"
              onClick={(e) => {
                e.preventDefault(); // Prevent default behavior
                handleButtonClick(button.href, button.label); // Call API with button label
              }}
              tabIndex={puck.isEditing ? -1 : undefined}
            >
              {button.label}
            </Button>
          ))}
        </div>
      </Section>
    );
  },
};
